<script type="ts">
    import { onMount } from 'svelte';
    import { getAuthenticatedData, postAuthenticatedData } from '../services/MyNemiServices';
    import type { IElearningSubscription } from '../models/backend';
    import LoadingProgress from './design/LoadingProgress.svelte';

    let loading = true;
    let subscriptions: IElearningSubscription[];

    onMount(() =>
    {
        getAuthenticatedData<IElearningSubscription[]>('/umbraco/api/mynemi/getsubscriptions')
            .then((response) =>
            {
                loading = false;
                subscriptions = response.data;
            });
    });

    function cancelSubscription(subscriptionId: string)
    {
        if (confirm('Voulez-vous réellement annuler le renouvellement ?'))
        {
            postAuthenticatedData<IElearningSubscription[]>('/umbraco/api/mynemi/cancelsubscription', {id: subscriptionId})
                .then((response) =>
                {
                    loading = false;
                    subscriptions = response.data;
                });
        }
    }
</script>

<div class="row">
    <div class="col-12">
        <h4>Abonnements actifs</h4>
    </div>
</div>

{#if loading}
    <LoadingProgress />
{/if}

{#if !loading && subscriptions.length === 0}
    <div class="row">
        <div class="col-12">
            <div class="alert alert-warning text-center" role="alert">
                Vous n'avez pas d'abonnement actif pour le moment.
            </div>
        </div>
    </div>
{/if}

{#if !loading && subscriptions.length !== 0}
    <div class="row">
        {#each subscriptions as subscription}
            <div class="col-12 pb-3">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">{subscription.description}</h5>

                        {#if subscription.active}
                            <div class="row">
                                <div class="col-6">Actif depuis le {subscription.startDate}</div>

                                {#if !subscription.cancelAtPeriodEnd}
                                    <div class="col-6 text-right">
                                        Renouvellement le {subscription.endDate}
                                    </div>
                                    <div class="col-6">
                                        {subscription.productType} : {subscription.price.toFixed(2)} &euro;
                                    </div>
                                    <div class="col-6 text-right">
                                        <a href={'#'} on:click={() => cancelSubscription(subscription.id)}>Annuler le renouvellement</a>
                                    </div>
                                {/if}

                                {#if subscription.cancelAtPeriodEnd}
                                    <div class="col-6 text-right">
                                        Actif jusqu'au {subscription.endDate}
                                    </div>
                                    <div class="col-12 pt-3 text-right">
                                        <i>L'abonnement ne sera pas renouvellé après cette date.</i>
                                    </div>
                                {/if}
                            </div>
                        {/if}

                        {#if !subscription.active}
                            <div class="row">
                                <div class="col-12">Vous n'avez pas d'abonnement actif pour ce cours.</div>
                                <div class="col-12">
                                    <a href={subscription.subscribeUrl}>Cliquez ici pour vous abonner.</a>
                                </div>
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        {/each}
    </div>
{/if}